<div class="detail-container">
  <nb-card size="giant">
    <nb-card-header>
      <div class="header">Gebäude QR-Codes</div>
    </nb-card-header>

    <nb-card-body class="qr-code-overview-page" [nbSpinner]="loading()">

      <div class="design-field">
        <div class="field-label" id="qr-design-label">Design</div>
        <nb-select
          fullWidth
          aria-label="Design"
          aria-labelledby="qr-design-label"
          data-cy="qr-design-select"
          [selected]="design()"
          (selectedChange)="design.set($event)">
          <nb-option data-cy="qr-design-option-gema" [value]="DesignEnum.Gema">Gema</nb-option>
          <nb-option data-cy="qr-design-option-wr" [value]="DesignEnum.Wr">Wohlschlager &amp; Redl</nb-option>
        </nb-select>
      </div>

      <div class="offset-settings">
        <div class="offset-field">
          <label class="field-label" for="offsetLeft">Offset links (mm)</label>
          <input
            id="offsetLeft"
            nbInput
            fullWidth
            type="number"
            step="0.1"
            [ngModel]="offsetLeft()"
            (ngModelChange)="offsetLeft.set($event)"
          />
        </div>

        <div class="offset-field">
          <label class="field-label" for="offsetTop">Offset oben (mm)</label>
          <input
            id="offsetTop"
            nbInput
            fullWidth
            type="number"
            step="0.1"
            [ngModel]="offsetTop()"
            (ngModelChange)="offsetTop.set($event)"
          />
        </div>
      </div>

      <div class="section-visibility">
        <div class="field-label">Hausnummern</div>
        <div class="section-visibility-options">
          <nb-checkbox [checked]="includeVisible()" (checkedChange)="includeVisible.set($event)">
            Sichtbare Hausnummern
          </nb-checkbox>
          <nb-checkbox [checked]="includeHidden()" (checkedChange)="includeHidden.set($event)">
            Versteckte Hausnummern
          </nb-checkbox>
        </div>
      </div>

      <wr-generic-pick-list
        [behaviour]="this"
        [(ngModel)]="selectedBuildingAssignments">
      </wr-generic-pick-list>
    </nb-card-body>

    <nb-card-footer class="footer">
      <button size="medium" nbButton status="primary" [disabled]="noSectionKindSelected() || loading()" (click)="submit()">
        Herunterladen
      </button>
      <button size="medium" nbButton status="basic" (click)="cancel()">Zurück</button>
    </nb-card-footer>
  </nb-card>
</div>
